// src/components/ui/CookieConsent.jsx — GDPR Cookie Consent Banner
import { useState, useEffect } from "react";
import PortalIcon from "./PortalIcon";

export default function CookieConsent({ t }) {
  const [show, setShow] = useState(false);
  const theme = t || {
    bg: "#070B14",
    bgCard: "#0F1629",
    gold: "#F59E0B",
    text: "#F1F5F9",
    muted: "#8892A4",
    border: "rgba(255,255,255,0.1)",
    accent: "#6366F1",
  };

  useEffect(() => {
    const consent = localStorage.getItem("dgh_cookie_consent");
    let timer;
    if (!consent) {
      timer = setTimeout(() => setShow(true), 1200);
    }
    return () => clearTimeout(timer);
  }, []);

  const acceptAll = () => {
    localStorage.setItem("dgh_cookie_consent", "all");
    setShow(false);
    // Enable Google Analytics
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: "granted" });
    }
  };

  const acceptNecessary = () => {
    localStorage.setItem("dgh_cookie_consent", "necessary");
    setShow(false);
    // Disable Google Analytics
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: "denied" });
    }
  };

  const openPrivacy = (e) => {
    e.preventDefault();
    window.dispatchEvent(new CustomEvent("dgh:navigate-page", { detail: { page: "privacy" } }));
  };

  if (!show) return null;

  return (
    <div style={{
      position: "fixed",
      bottom: "calc(12px + env(safe-area-inset-bottom, 0px))",
      left: "12px",
      right: "12px",
      zIndex: 1200,
      background: theme.bgCard,
      border: `1px solid ${theme.border}`,
      padding: "14px",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
      maxWidth: "520px",
      margin: "0 auto",
      borderRadius: "14px",
      boxShadow: "0 20px 70px rgba(0,0,0,.28)",
      animation: "slideUp .3s ease",
    }}>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        @media (min-width: 720px) {
          .cookie-consent-actions { flex-wrap: nowrap !important; }
        }
      `}</style>

      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "8px" }}>
          <span style={{ width:34, height:34, borderRadius:10, background:`${theme.gold}18`, color:theme.gold, display:"flex", alignItems:"center", justifyContent:"center" }}><PortalIcon name="shield" size={18} /></span>
          <strong style={{ color: theme.text, fontSize: "1rem" }}>We value your privacy</strong>
        </div>
        <p style={{
          color: theme.muted,
          fontSize: ".82rem",
          lineHeight: 1.55,
          margin: 0,
        }}>
          We use cookies to improve your browsing experience and understand what works on the site.{" "}
          <a
            href="#privacy"
            onClick={openPrivacy}
            style={{ color: theme.gold, textDecoration: "underline", fontWeight: 600, cursor: "pointer" }}
          >
            Learn more
          </a>
        </p>
      </div>

      <div className="cookie-consent-actions" style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <button
          onClick={acceptAll}
          style={{
            flex: 1,
            minWidth: "120px",
            padding: "12px 20px",
            background: `linear-gradient(135deg, ${theme.gold}, #F97316)`,
            color: "#070B14",
            border: "none",
            borderRadius: "10px",
            fontWeight: 700,
            fontSize: ".88rem",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          <PortalIcon name="check" size={15} style={{ marginRight:6 }} />Accept All
        </button>
        <button
          onClick={acceptNecessary}
          style={{
            flex: 1,
            minWidth: "120px",
            padding: "12px 20px",
            background: "transparent",
            color: theme.muted,
            border: `1px solid ${theme.border}`,
            borderRadius: "10px",
            fontWeight: 600,
            fontSize: ".88rem",
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          <PortalIcon name="settings" size={15} style={{ marginRight:6 }} />Necessary Only
        </button>
      </div>
    </div>
  );
}
